import request from '../request'

export default {
  getInfraestructuras(data) {
    return request.get('infraestructura', data)
  },
  addInfraestructura(data) {
    return request.post('infraestructura', data)
  },
  updateInfraestructura(data) {
    return request.put('infraestructura', data)
  },
  getTipos() {
    return request.get('infraestructura_tipo')
  },
  getCategorias() {
    return request.get('infraestructura_categoria')
  },
  getMunicipios() {
    return request.get('municipio')
  },
  getProvincias() {
    return request.get('provincia')
  },
  getResponsables() {
    return request.get('organismo')
  }

}
